import AITTLoginPage from "./customLoginPages/AITTLoginPage"
import DefaultLoginPage from "./DefaultLoginPage"

const Login = () => {

  if(window.configs.showCustomLoginPage && window.configs.showCustomLoginClientName){
    let clientName = window.configs.showCustomLoginClientName;
    switch (clientName) {
      case "AITT":
        return (
          <AITTLoginPage/>
        )
    
      default:
        return (
          <DefaultLoginPage/>
        )
    }
  }else{
    return (
      <DefaultLoginPage/>    
    )
  }
}

export default Login